module.exports = __webpack_public_path__ + "static/img/2.44aa9b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/new/2.jpg
// module id = pq8j
// module chunks = 0